import CheckIcon from '@/shared/assets/icons/conversion/checkIcon.svg?react'

interface ConversionBlockProps {
  current: number
  goal: number
  variant?: 'card' | 'table'
}

export const ConversionBlock = ({ current, goal, variant = 'card' }: ConversionBlockProps) => {
  const textClasses = variant === 'card' ? 'text-sm md:text-base' : 'text-sm'
  const percentage = goal === 0 ? '0' : ((current / goal) * 100).toFixed(0)

  const formattedCurrent = new Intl.NumberFormat('ru-RU').format(current)
  const formattedGoal = new Intl.NumberFormat('ru-RU').format(goal)

  return (
    <div className={`flex items-center gap-1 font-klein font-medium ${textClasses}`}>
      <CheckIcon />
      <span>{percentage}% </span>
      <span className="text-text-secondary">
        {formattedCurrent}/{formattedGoal}
      </span>
    </div>
  )
}
